export default __webpack_public_path__ + "static/media/herogirl.7f6b4340.png";